'use client';

import { HStack, VStack } from '@terra/ui-styled-system';
import { IconButton } from '../../../components/icon-button';
import { Message02Icon, ThumbsDownIcon, ThumbsUpIcon } from '@terra/ui-icons';
import { Tooltip } from '../../../components/tooltip';
import { useChatFeedback } from './ChatFeedbackProvider';
import { useTranslations } from 'next-intl';

type FeedbackActionsProps = {
  traceId: string;
};

export function FeedbackActions({ traceId }: FeedbackActionsProps) {
  const t = useTranslations('designSystem.chat.feedbackActions');
  const {
    isEnabled,
    onFeedbackClick,
    getTraceSubmittingState,
    getTraceSubmittedRating,
  } = useChatFeedback();
  const isSubmitting = getTraceSubmittingState(traceId);
  const submittedRating = getTraceSubmittedRating(traceId);

  if (!isEnabled) return null;
  const thumbsFill = (rating: 'positive' | 'negative') =>
    submittedRating === rating ? 'currentColor' : 'none';

  return (
    <VStack gap={0} mt={2} w="full" alignItems="flex-start">
      <HStack gap={0.5}>
        <IconButton
          aria-label={t('thumbsUp')}
          variant="ghost"
          size="xs"
          onClick={() => onFeedbackClick({ traceId, actionType: 'positive' })}
          disabled={isSubmitting}
        >
          <ThumbsUpIcon size={14} fill={thumbsFill('positive')} />
        </IconButton>
        <IconButton
          aria-label={t('thumbsDown')}
          variant="ghost"
          size="xs"
          onClick={() => onFeedbackClick({ traceId, actionType: 'negative' })}
          disabled={isSubmitting}
        >
          <ThumbsDownIcon size={14} fill={thumbsFill('negative')} />
        </IconButton>
        <Tooltip title={t('addDetailedFeedback')}>
          <IconButton
            aria-label={t('addDetailedFeedback')}
            variant="ghost"
            size="xs"
            onClick={() => onFeedbackClick({ traceId, actionType: 'general' })}
            disabled={isSubmitting}
          >
            <Message02Icon size={14} />
          </IconButton>
        </Tooltip>
      </HStack>
    </VStack>
  );
}
